import { TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";

const ImageUploadOptionSection = ({
  productCheckNotice,
  setProductCheckNotice,
}: {
  productCheckNotice: string;
  setProductCheckNotice: (v: string) => void;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_edit.image_upload_option.title")}
      rows={[
        {
          label: t(
            "quest_edit.image_upload_option.form.check_dialog_notice.label",
          ),
          children: (
            <>
              <TextField
                size="small"
                sx={{ width: "50%" }}
                value={productCheckNotice}
                onChange={(e) => setProductCheckNotice(e.target.value)}
              ></TextField>
              <Typography
                variant="body2"
                sx={{ color: "text.secondary", mt: 1 }}
              >
                {t(
                  "quest_edit.image_upload_option.form.check_dialog_notice.note",
                )}
              </Typography>
            </>
          ),
        },
      ]}
    />
  );
};

export default ImageUploadOptionSection;
